// 언어마다 존재하는 path의 경우: 아래의 getRedirectPath 사용 - 언어 호환이 어려워 대체 경로로 이동
// 언어에 존재하지않는 path의 경우: next.config.js 에서 리다이렉트 처리

/**
 * 언어 전환 시 현재 경로를 그대로 쓸 수 없는 경로 접두사 → 대체 목적지.
 *
 * 블로그·뉴스는 글 slug 가 언어별로 다르고 목록 페이지 수도 로케일별로 달라, 같은 경로를
 * 반대 언어로 그대로 열 수 없다. 그래서 각 섹션의 진입점으로 잘라 보낸다 — 블로그는 랜딩
 * (`/blog`), 뉴스는 아카이브 1페이지(`/news/category/all/1`).
 *
 * 뉴스 목적지가 `/news` 가 아닌 이유: `/news` 는 next.config 리다이렉트(308)라 한 번 더
 * 튄다. 최종 도착지를 바로 가리켜 리다이렉트 체인을 없앤다.
 *
 * ⚠️ **항목을 지우지 말 것** — 목록에서 빠지면 아래 `find` 가 못 찾아 "원래 경로 유지"로
 * 넘어가고, 언어별로 존재하지 않는 slug 로 떨어진다(`/blog/{ko-slug}` → 영문에서 404).
 */
const TOGGLE_LANG_FALLBACK: readonly (readonly [
  prefix: string,
  destination: string,
])[] = [
  ['/blog', '/blog'],
  ['/news', '/news/category/all/1'],
];

/**
 * 언어 토글이 이동할 경로를 정한다. locale prefix 는 붙이지 않는다 —
 * 호출부(`router.replace(path, { locale })`)가 처리한다.
 */
export const getRedirectPath = (pathname: string) => {
  const matched = TOGGLE_LANG_FALLBACK.find(
    ([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

  return matched ? matched[1] : pathname;
};
